import { Directive } from "../Directive.js";
import type { PlayerState } from "../../../../royalur/model/PlayerState.js";
import { PlayerType } from "../../../../royalur/model/PlayerType.js";


/**
 * A directive for rendering the state of the player.
 */
export abstract class PlayerStateDirective extends Directive {
    readonly moveIndex: number;

    protected constructor(directiveID: number, moveIndex: number) {
        super(directiveID);
        this.moveIndex = moveIndex;
    }

    override isLimboDirective(): boolean {
        return true;
    }

    abstract getActivePlayer(moveIndex: number): PlayerType;

    abstract getLightPlayerState(moveIndex: number): PlayerState;

    abstract getDarkPlayerState(moveIndex: number): PlayerState;

    getPlayerState(player: PlayerType, moveIndex: number): PlayerState {
        switch (player) {
            case PlayerType.LIGHT:
                return this.getLightPlayerState(moveIndex);
            case PlayerType.DARK:
                return this.getDarkPlayerState(moveIndex);
            default:
                throw new Error("Unknown player type " + JSON.stringify(player));
        }
    }
}
